const mutations = {
    setQueues(state, { queues }) {
        state.items = queues
    },
}

export default mutations
